<template>
    <v-container fluid>
        <v-data-table :headers="headers"
                      fixed-header
                      fixed-footer
                      show-expand
                      single-expand
                      height="600px"
                      :items="roles"
                      :options.sync="options"
                      :loading="loading"
                      :footer-props="footerProps"
                      :search="search"
                      class="elevation-1">
            <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-toolbar-title>Roles Administration</v-toolbar-title>
                    <v-divider class="mx-4"
                               inset
                               vertical></v-divider>
                    <v-spacer></v-spacer>
                    <v-text-field v-model="search"
                                  append-icon="mdi-magnify"
                                  label="Search"
                                  single-line
                                  hide-details></v-text-field>
                    <v-dialog v-model="dialog" max-width="500px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn color="primary"
                                   dark
                                   class="mb-2 ml-8"
                                   v-bind="attrs"
                                   v-on="on"><v-icon>mdi-shield-plus-outline</v-icon></v-btn>
                        </template>
                        <v-card>
                            <v-form ref="form" v-model="valid">
                                <v-card-title>
                                    <span class="headline">{{ formTitle }}</span>
                                </v-card-title>

                                <v-card-text>
                                    <v-container>
                                        <v-text-field v-model="editedItem.id"
                                                      @blur="editedItem.id = editedItem.id.toUpperCase()"
                                                      label="Role ID *"
                                                      :readonly="editedIndex != -1"
                                                      :counter="32"
                                                      :rules="rules.id"
                                                      required></v-text-field>
                                        <v-text-field v-model="editedItem.name"
                                                      label="Name *"
                                                      :counter="64"
                                                      :rules="rules.name"
                                                      required></v-text-field>
                                        <v-text-field v-model="editedItem.description"
                                                      label="Description *"
                                                      :counter="128"
                                                      :rules="rules.description"
                                                      required></v-text-field>
                                        <small>* indicates required field</small>
                                    </v-container>
                                </v-card-text>

                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-1"
                                           text
                                           @click="close">Cancel</v-btn>
                                    <v-btn color="blue darken-1"
                                           text
                                           :disabled="!valid"
                                           :loading="submitting"
                                           @click="saveRole">Save</v-btn>
                                </v-card-actions>
                            </v-form>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-icon small
                        class="mr-2"
                        @click="editItem(item)">
                    mdi-pencil
                </v-icon>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                    <v-row>
                        <v-col v-for="feature in getFeaturesByRole(item.id)"
                               v-bind:key="'feature-'+feature.id"
                               cols="12" sm="6" md="4" lg="3">
                            <v-switch v-model="feature.isGranted"
                                      :label="feature.featureName"
                                      :hint="feature.featureDescription"
                                      @change="togglePermission(feature)"
                                      persistent-hint></v-switch>
                        </v-col>
                    </v-row>
                </td>
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
    import appsettings from '../../appsettings.js';
    import { mapActions, mapGetters } from 'vuex';
    import axios from "axios";
    export default {
        data() {
            return {
                roles: [],
                features: [],
                search: null,
                loading: false,
                dialog: false,
                valid: false,
                submitting: false,
                defaultItem: {
                    id: "",
                    name: "",
                    description: ""
                },
                rules: {
                    name: [
                        v => !!v || 'Name is required',
                        v => (v && v.length >= 3) || 'Name must be at least 3 characters',
                        v => (v && v.length <= 64) || 'Name must be equal or less than 64 characters'
                    ],
                    description: [
                        v => !!v || 'Description is required',
                        v => (v && v.length >= 3) || 'Description must be at least 3 characters',
                        v => (v && v.length <= 128) || 'Description must be equal or less than 128 characters'
                    ],
                    id: [
                        v => !!v || 'ID is required',
                        v => (v && v.length >= 3) || 'ID must be at least 3 characters',
                        v => (v && v.length <= 32) || 'ID must be equal or less than 32 characters'
                    ]
                },
                headers: [
                    {
                        text: 'Role ID',
                        align: 'start',
                        value: 'id'
                    },
                    {
                        text: 'Name',
                        value: 'name'
                    },
                    {
                        text: 'Description',
                        value: 'description'
                    },
                    { text: 'Actions', value: 'actions', sortable: false },
                ],
                footerProps: {
                    'items-per-page-options': appsettings.config.pages
                },
                editedIndex: -1,
                editedItem: {},
                options: {}
            }
        },
        computed: {
            ...mapGetters(['getVrsUser']),
            formTitle() {
                return this.editedIndex === -1 ? 'Add New Role' : 'Edit Role'
            },
        },
        methods: {
            ...mapActions(["sendMessage"]),
            async getDataFromApi() {

                this.loading = true;
                let response = await axios.get(`/api/Role`);
                this.loading = false;
                return response.data;

            },
            async getFeaturesFromApi() {

                this.loading = true;
                let response = await axios.get(`/api/Role/ALL/features`);
                this.loading = false;
                return response.data;

            },
            async refreshFeatures() {
                this.features = await this.getFeaturesFromApi();
            },
            close() {
                this.dialog = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                })
            },
            editItem(role) {
                this.editedIndex = this.roles.indexOf(role);
                this.editedItem = Object.assign({}, role);
                this.dialog = true;
            },
            async saveRole() {
                if (this.valid) {

                    let role = { ...this.editedItem };

                    let isNew = this.editedIndex == -1;

                    this.submitting = true;
                    let data = null;
                    try {
                      let response = null;
                      if(isNew) {
                        response = await axios.post(`/api/Role`,role);
                      }
                      else {
                        response = await axios.put(`/api/Role`,role);
                      }
                      data = response.data;
                    }
                    catch(error) {
                      role.errorMessage = 'An unknown network has occurred.';
                      role.hasError = true;

                      return role;
                    }
                    
                    let found = this.roles.some(role => role.id === data.id);
                    if (!found) this.roles.push(data);
                    this.roles = this.roles.map(role => [data].find(newRole => newRole.id === role.id) || role);
                    this.refreshFeatures();
                    this.sendMessage({
                        color: "success",
                        text: `The user ${data.name} has been successfuly updated.`,
                        timeout: 6000
                    });

                    this.$nextTick(() => {
                        this.editedItem = Object.assign({}, this.defaultItem)
                        this.editedIndex = -1
                    });
                    this.submitting = false;
                    this.dialog = false;

                    return data;


                }

            },
            async togglePermission(feature) {

                this.loading = true;
                
                try {
                  let response = await axios.patch(`/api/Role/${feature.roleId}/features/${feature.featureId}/${feature.id}`,feature);
                  let data = response.data;
                  this.features = this.features.map(ft => [data].find(newFt => newFt.id === ft.id) || ft);

                  this.loading = false;

                  return data;
                }
                catch(error) {
                  this.features = this.features.map(ft => [feature].find(newFt => newFt.id === ft.id) || ft);
                  this.sendMessage({
                    color: "error",
                    text: `Failed to update the permission. Please, try again.`,
                    timeout: 6000
                  });
                  return feature;
                }
            },
            getFeaturesByRole(roleId) {
                return this.features.filter(feature => feature.roleId === roleId);
            }
        },
        async mounted() {
            this.options.itemsPerPage = this.getVrsUser.pageSize ?? appsettings.default.pageSize;
            this.roles = await this.getDataFromApi();
            this.features = await this.getFeaturesFromApi();
        }
    }
</script>

<style>
</style>